/**
 * Class to represent kindergarten organization.
 */

import { OrganizationContract } from '../../contracts/organization.contract';

export class Organization {
  constructor(public officialName: string) {}

  /**
   * Deserialize JSON to typescript object.
   *
   * @param data
   */
  public static deserialize(data: OrganizationContract): Organization {
    return new Organization(data.official_name);
  }

  /**
   * Serialize typescript object into basic javascript types.
   */
  public serialize(): OrganizationContract {
    return {
      official_name: this.officialName,
    };
  }
}
